import { typography } from "./typography";

export const baseTheme = {
  typography,
};
